import { render, staticRenderFns } from "./CustomProxer.vue?vue&type=template&id=cb749bbe&scoped=true&"
import script from "./CustomProxer.vue?vue&type=script&lang=js&"
export * from "./CustomProxer.vue?vue&type=script&lang=js&"
import style0 from "./CustomProxer.vue?vue&type=style&index=0&id=cb749bbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb749bbe",
  null
  
)

export default component.exports